function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import ve from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { convertMsToSeconds as O } from "../util/date-utils.js";
import { logger as N, Guid as K, EventTypes as d } from "../../shared-lib/index.js";

var Wt = /*#__PURE__*/function () {
  function Wt(s, t, i, e) {
    _classCallCheck(this, Wt);

    this.C = s, this.Cs = t, this.B = i, this.Sl = e, this.C = s, this.Cs = t, this.B = i, this.jl = 1e3, (null == e || isNaN(e)) && (e = 1800), e < this.jl / 1e3 && (N.info("Specified session timeout of " + e + "s is too small, using the minimum session timeout of " + this.jl / 1e3 + "s instead."), e = this.jl / 1e3), this.Sl = e;
  }

  _createClass(Wt, [{
    key: "xl",
    value: function xl(s, t) {
      return new ve(this.Cs.getUserId(), d.Dl, s, t.eu, {
        d: O(s - t.Gl)
      });
    }
  }, {
    key: "St",
    value: function St() {
      var t = this.C.tu(s.iu.Nl);
      return null == t ? null : t.eu;
    }
  }, {
    key: "zl",
    value: function zl() {
      var t = new Date().valueOf(),
          i = this.B.wl();
      if (null == i) return !1;
      var e = this.C.ft(s.gt.Hl),
          n = null == e || t - e > 1e3 * i;
      return n && this.C.Bt(s.gt.Hl, t), n;
    }
  }, {
    key: "Wl",
    value: function Wl(s, t) {
      return null == t || null == t.kl || !(s - t.Gl < this.jl) && t.kl < s;
    }
  }, {
    key: "Qo",
    value: function Qo() {
      var t = new Date().valueOf(),
          i = t + 1e3 * this.Sl,
          e = this.C.tu(s.iu.Nl);

      if (this.Wl(t, e)) {
        var n = "Generating session start event with time " + t;

        if (null != e) {
          var _s = e.ql;
          _s - e.Gl < this.jl && (_s = e.Gl + this.jl), this.C.Al(this.xl(_s, e)), n += " (old session ended " + _s + ")";
        }

        n += ". Will expire " + i.valueOf(), N.info(n);
        var o = new _t(K.ce(), i);
        this.C.Al(new ve(this.Cs.getUserId(), d.Fl, t, o.eu)), this.C.uu(s.iu.Nl, o);
        return null == this.C.ft(s.gt.Hl) && this.C.Bt(s.gt.Hl, t), o.eu;
      }

      if (null != e) return e.ql = t, e.kl = i, this.C.uu(s.iu.Nl, e), e.eu;
    }
  }, {
    key: "Il",
    value: function Il() {
      var t = this.C.tu(s.iu.Nl);
      null != t && (this.C.Jl(s.iu.Nl), this.C.Al(this.xl(new Date().valueOf(), t)));
    }
  }]);

  return Wt;
}();

export { Wt as default };